module.exports = __webpack_public_path__ + "static/img/level1.e15ab286.png";